import { differenceInCalendarDays, parseISO } from "date-fns";

import { OPEN_TASK_STATUSES } from "@recobra/schemas/task";
import { type Task, taskCalendarDate } from "@recobra/schemas/task";

const DUE_SOON_WINDOW_DAYS = 2;

type TaskDeadlineUrgency =
  | { level: "overdue"; days: number }
  | { level: "today" }
  | { level: "soon"; days: number };

/**
 * How close an open task's end deadline is to `now`, counted in days of the task calendar.
 * `null` for done tasks, tasks without a deadline, and deadlines beyond the due-soon window.
 */
export const taskDeadlineUrgency = (
  task: Pick<Task, "status" | "deadlineDate">,
  now: Date,
): TaskDeadlineUrgency | null => {
  if (!OPEN_TASK_STATUSES.includes(task.status) || !task.deadlineDate) return null;

  const daysLeft = differenceInCalendarDays(
    parseISO(task.deadlineDate),
    parseISO(taskCalendarDate(now)),
  );
  if (daysLeft < 0) return { level: "overdue", days: -daysLeft };
  if (daysLeft === 0) return { level: "today" };
  if (daysLeft <= DUE_SOON_WINDOW_DAYS) return { level: "soon", days: daysLeft };

  return null;
};
